import { getTotalStopTime } from '../../util';
import { getNoFreightStatusLabel } from '../../../../Dispatch/utils/utils';
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import { getStopDetails } from "./utils";
import constants from "./constants";
import reportConstants from '../../constants';
import StopTime from "./common/CompletedStopTimeRenderer";

const isPickupNoFreightStop = (stopData) => {
  const { DISPATCH_STOP_TYPES } = reportConstants;
  return (
    stopData?.stopType === DISPATCH_STOP_TYPES.PICKUP &&
    !stopData?.shipments?.some((shipment) => shipment?.proId)
  );
};

const CompletedStopPopup = ({
  task,
  DispatchStore,
  enableReturnExceptionReasonLabels = false,
  enableNoFreightCode = false,
  enableRevisitDeliveryStop = false
}) => {
  const stopData = task.data;
  const { stopStatus, stopStatusClass } = getStopDetails(stopData);
  const plannedStopTime = getTotalStopTime(
    stopData?.plannedArrivalTime,
    stopData?.plannedDepartureTime
  );

  const stopStatusCodes =
    enableNoFreightCode && isPickupNoFreightStop(stopData) && stopData.noFreightCode
      ? getNoFreightStatusLabel(
          stopData.noFreightCode,
          DispatchStore?.staticClientData?.clientCodes?.noFreightCode,
          enableReturnExceptionReasonLabels
        )
      : '';

  return (
    <PickupDeliveryPopupRenderer
      stopType={stopData?.stopType}
      arrivalTime={task.arrivalTime}
      departureTime={task.departureTime}
      stopTime={<StopTime actualStopTime={task.stopDuration} plannedStopTime={plannedStopTime} />}
      stopTimeClass="completedStopTime"
      stopTimeHeaderClass="completedStopTimeHeader"
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={stopStatusClass}
      serviceWindow={stopData}
      stopData={stopData}
      statusCodes={stopStatusCodes}
      enableRevisitDeliveryStop={enableRevisitDeliveryStop}
    />
  );
};

export default CompletedStopPopup;
